// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../../resources/images/spinner.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3TXPvgAqZoaTP6._1wHQPrV6u7Be-A._2wnC2LnsQKUq3x {\n  text-align: center;\n}\n._3TXPvgAqZoaTP6._1wHQPrV6u7Be-A > ._3pnGZjOBuYrXfP {\n  margin: 0 auto;\n}\n._3TXPvgAqZoaTP6._2wnC2LnsQKUq3x > ._3pnGZjOBuYrXfP {\n  display: inline-block;\n  vertical-align: middle;\n}\n._3pnGZjOBuYrXfP {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-size: 30px 30px;\n  display: block;\n  height: 30px;\n  width: 30px;\n}\n._3pnGZjOBuYrXfP._3Wb2ZSR16XWCEs {\n  background-size: 18px 18px;\n  height: 18px;\n  width: 18px;\n}\n._3pnGZjOBuYrXfP._QKSnABh0yljDj {\n  margin-right: 3px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_3TXPvgAqZoaTP6",
	"centered": "_1wHQPrV6u7Be-A",
	"inline": "_2wnC2LnsQKUq3x",
	"spinner": "_3pnGZjOBuYrXfP",
	"small": "_3Wb2ZSR16XWCEs",
	"modLeft": "_QKSnABh0yljDj"
};
export default ___CSS_LOADER_EXPORT___;
